import React from 'react';

const EyeShowedIcon = () => (
    <svg className="icon eye-icon eye-showed-icon" viewBox="0 0 20 12">
        <path d="M10 0C6.179 0 2.714 2.104.156 5.522c-.208.28-.208.672 0 .952C2.714 9.896 6.18 12 10 12c3.821 0 7.286-2.104 9.844-5.522.208-.28.208-.672 0-.952C17.286 2.104 13.82 0 10 0zm.26 9.992c-2.412.152-4.404-1.837-4.252-4.253.125-1.992 1.74-3.606 3.731-3.73 2.413-.153 4.405 1.836 4.253 4.252-.129 1.988-1.743 3.602-3.731 3.73zm-.132-1.996c-1.206.076-2.203-.918-2.124-2.124.062-.997.87-1.803 1.868-1.868 1.206-.076 2.203.918 2.124 2.124-.065 1-.875 1.807-1.868 1.868z" />
    </svg>
);

export default EyeShowedIcon;
